import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { CardService } from './card.service';
import { CardSearchComponent } from './card-search/card-search.component';
import { CommonModule } from '../common/common.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CardGridComponent } from './card-grid/card-grid.component';
import { CardTableComponent } from './card-table/card-table.component';
import { CardPickerComponent } from './card-picker/card-picker.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PrettyCardListComponent } from './pretty-card-list/pretty-card-list.component';
import { GtagModule } from 'angular-gtag';
import { CardImageComponent } from '../common/card-image/card-image.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CardViewComponent } from './card-view/card-view.component';
import { MatMenuModule } from '@angular/material/menu';
import { ImporterComponent } from './importer/importer.component';
import { ManualImporterComponent } from './manual-importer/manual-importer.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FileImporterComponent } from './file-importer/file-importer.component';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxDropzoneModule } from 'ngx-dropzone';

@NgModule({
    providers: [CardService],
    declarations: [
        CardSearchComponent,
        CardGridComponent,
        CardTableComponent,
        CardPickerComponent,
        PrettyCardListComponent,
        PrettyCardListComponent,
        CardImageComponent,
        CardViewComponent,
        ImporterComponent,
        ManualImporterComponent,
        FileImporterComponent
    ],
    exports: [
        CardSearchComponent,
        CardGridComponent,
        CardTableComponent,
        CardPickerComponent,
        PrettyCardListComponent,
        CardImageComponent
    ],
    imports: [
        NgCommonModule,
        CommonModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatSlideToggleModule,
        MatToolbarModule,
        MatDialogModule,
        MatRippleModule,
        DragDropModule,
        GtagModule,
        MatTooltipModule,
        MatMenuModule,
        EditorModule,
        MatSelectModule,
        FormsModule,
        MatStepperModule,
        NgxDropzoneModule
    ]
})
export class CardsModule {}
